"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllBrokingSlipVersionsSwaggerMetadata = exports.updateHandOverMeetingSwaggerMetadata = exports.updateKDMMeetingSwaggerMetadata = exports.getMeetingByIdSwaggerMetadata = exports.getDataValidationByOpportunityActivityIdSwaggerMetadata = exports.createDataValidationSwaggerMetadata = exports.getOpportunityActivityByIdSwaggerMetadata = exports.getOpportunityByIdSwaggerMetadata = exports.getAllOpportunitiesSwaggerMetadata = void 0;
exports.createOpportunitySwaggerMetadata = createOpportunitySwaggerMetadata;
exports.updateOpportunityByIdSwaggerMetadata = updateOpportunityByIdSwaggerMetadata;
exports.deleteOpportunityByIdSwaggerMetadata = deleteOpportunityByIdSwaggerMetadata;
exports.createFinalNegotiationMeetingSwaggerMetadata = createFinalNegotiationMeetingSwaggerMetadata;
exports.updateOpportunityActivitiesSwaggerMetadata = updateOpportunityActivitiesSwaggerMetadata;
exports.getOpportunityActivityMetaSwaggerMetadata = getOpportunityActivityMetaSwaggerMetadata;
exports.createKDMMeetingSwaggerMetadata = createKDMMeetingSwaggerMetadata;
exports.createOpportunityActivitySwaggerMetadata = createOpportunityActivitySwaggerMetadata;
exports.getRfpDataByOpportunityIdSwaggerMetadata = getRfpDataByOpportunityIdSwaggerMetadata;
exports.getOpportunityCoversMetaSwaggerMetadata = getOpportunityCoversMetaSwaggerMetadata;
exports.createMandateSwaggerMetadata = createMandateSwaggerMetadata;
exports.getMandateDetailsByOpportunityActivityIdSwaggerMetadata = getMandateDetailsByOpportunityActivityIdSwaggerMetadata;
exports.getPolicyDocketByOpportunityActivityIdSwaggerMetadata = getPolicyDocketByOpportunityActivityIdSwaggerMetadata;
exports.getOpportunityActivitySwaggerMetadata = getOpportunityActivitySwaggerMetadata;
exports.updatePolicyDocketByIdSwaggerMetadata = updatePolicyDocketByIdSwaggerMetadata;
exports.updateQuoteSwaggerMetadata = updateQuoteSwaggerMetadata;
exports.updateOpportunityQuoteByActivityIdSwaggerMetadata = updateOpportunityQuoteByActivityIdSwaggerMetadata;
exports.getQuoteByBrokingSlipAndActivitySwaggerMetadata = getQuoteByBrokingSlipAndActivitySwaggerMetadata;
exports.getQuotesByBrokingSlipSwaggerMetadata = getQuotesByBrokingSlipSwaggerMetadata;
exports.updateHeldCoverNoteByIdSwaggerMetadata = updateHeldCoverNoteByIdSwaggerMetadata;
exports.updatePolicyConfirmationByIdSwaggerMetadata = updatePolicyConfirmationByIdSwaggerMetadata;
exports.updatePolicyHardCopyByIdSwaggerMetadata = updatePolicyHardCopyByIdSwaggerMetadata;
exports.updateFinalNegotiationActivitySwaggerMetadata = updateFinalNegotiationActivitySwaggerMetadata;
exports.getFinalNegotiationActivitySwaggerMetadata = getFinalNegotiationActivitySwaggerMetadata;
exports.createFinalNegotiationActivitySwaggerMetadata = createFinalNegotiationActivitySwaggerMetadata;
exports.getOpportunitiesByCompanyIdSwaggerMetadata = getOpportunitiesByCompanyIdSwaggerMetadata;
exports.createPlacementSlipSwaggerMetadata = createPlacementSlipSwaggerMetadata;
exports.updatePlacementSlipSwaggerMetadata = updatePlacementSlipSwaggerMetadata;
exports.deletePlacementSlipSwaggerMetadata = deletePlacementSlipSwaggerMetadata;
exports.updateQuoteComparisonReportByIdSwaggerMetadata = updateQuoteComparisonReportByIdSwaggerMetadata;
exports.getOpportunityContactsSwaggerMetadata = getOpportunityContactsSwaggerMetadata;
exports.generateQuoteComparisonReportSwaggerMetadata = generateQuoteComparisonReportSwaggerMetadata;
exports.getQuoteEntryDetailsSwaggerMetadata = getQuoteEntryDetailsSwaggerMetadata;
exports.getPolicyConfirmationCdAccountDetailsSwaggerMetadata = getPolicyConfirmationCdAccountDetailsSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const opportunity_query_param_dto_1 = require("./dto/opportunity-query-param.dto");
const create_opportunity_dto_1 = require("./dto/create-opportunity.dto");
const opportunity_list_response_dto_1 = require("./dto/opportunity-list-response.dto");
const opportunity_activity_dto_1 = require("./dto/opportunity-activity.dto");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const get_opportunity_by_id_dto_1 = require("./dto/get-opportunity-by-id.dto");
const create_final_negotiation_dto_1 = require("./dto/create-final-negotiation.dto");
const create_kdm_meeting_dto_1 = require("./dto/create-kdm-meeting.dto");
const get_metting_by_id_dto_1 = require("./dto/get-metting-by-id.dto");
const opportunity_activities_dto_1 = require("./dto/opportunity-activities.dto");
const create_mandate_details_dto_1 = require("./dto/create-mandate-details.dto");
const create_data_validation_dto_1 = require("./dto/create-data-validation.dto");
const create_quote_entry_dto_1 = require("./dto/create-quote-entry.dto");
const update_held_cover_note_dto_1 = require("./dto/update-held-cover-note.dto");
const update_policy_confirmation_dto_1 = require("./dto/update-policy-confirmation.dto");
const update_policy_hard_copy_dto_1 = require("./dto/update-policy-hard-copy.dto");
const qcr_broking_slip_version_details_dto_1 = require("./dto/qcr-broking-slip-version-details.dto");
const update_final_negotiation_activity_dto_1 = require("./dto/update-final-negotiation-activity.dto");
const create_final_negotiation_activity_dto_1 = require("./dto/create-final-negotiation-activity.dto");
const create_placement_slip_dto_1 = require("./dto/create-placement-slip.dto");
const update_placement_slip_dto_1 = require("./dto/update-placement-slip.dto");
const update_quote_comparison_report_dto_1 = require("./dto/update-quote-comparison-report.dto");
const generate_quote_comparison_report_dto_1 = require("./dto/generate-quote-comparison-report.dto");
const getAllOpportunitiesSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Retrieve all opportunities",
        description: "Fetches all opportunities with optional search, sorting, and pagination.",
    }), ...Object.keys(opportunity_query_param_dto_1.GetOpportunityQueryDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", opportunity_query_param_dto_1.GetOpportunityQueryDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", opportunity_query_param_dto_1.GetOpportunityQueryDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.opportunityListRetrieved,
        type: opportunity_list_response_dto_1.OpportunityListResponseDto, // Reference the DTO here
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
};
exports.getAllOpportunitiesSwaggerMetadata = getAllOpportunitiesSwaggerMetadata;
function createOpportunitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_opportunity_dto_1.CreateOpportunityDto), (0, swagger_1.ApiOperation)({
        summary: "Create a new opportunity",
        description: "Creates a new opportunity with the provided details.",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for creating an opportunity.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_opportunity_dto_1.CreateOpportunityDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.opportunityCreated,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.opportunityCreated,
                },
                data: {
                    type: "object",
                    $ref: (0, swagger_1.getSchemaPath)(get_opportunity_by_id_dto_1.OpportunityGetResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.opportunityCreationFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.opportunityCreationFailed,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
const getOpportunityByIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Retrieve opportunity data by ID" }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityId",
        description: "The ID of the opportunity",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.opportunityDetails,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.opportunityDetails,
                },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(get_opportunity_by_id_dto_1.OpportunityGetResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.opportunityNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.opportunityNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
};
exports.getOpportunityByIdSwaggerMetadata = getOpportunityByIdSwaggerMetadata;
function updateOpportunityByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Update an opportunity by ID",
        description: "Updates the details of an opportunity by its ID.",
    }), (0, swagger_1.ApiParam)({
        name: "opportunityId",
        required: true,
        description: "The ID of the opportunity to update.",
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating an opportunity.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_opportunity_dto_1.CreateOpportunityDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.opportunityUpdated,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.opportunityUpdated,
                },
                data: {
                    type: "object",
                    $ref: (0, swagger_1.getSchemaPath)(get_opportunity_by_id_dto_1.OpportunityGetResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.opportunityNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.opportunityNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function deleteOpportunityByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Delete an opportunity by ID",
        description: "Deletes an opportunity by its ID.",
    }), (0, swagger_1.ApiParam)({
        name: "opportunityId",
        required: true,
        description: "The ID of the opportunity to delete.",
        example: 1,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.opportunityDeleted,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.opportunityDeleted,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.opportunityNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.opportunityNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function createFinalNegotiationMeetingSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_final_negotiation_dto_1.CreateFinalNegotiationDto), (0, swagger_1.ApiOperation)({
        summary: "Create a final negotiation meeting",
        description: "Creates a final negotiation meeting and stores insurer participants if provided.",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for creating a final negotiation meeting.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_final_negotiation_dto_1.CreateFinalNegotiationDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "Final negotiation meeting created successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: {
                    type: "string",
                    example: "Final negotiation meeting created successfully.",
                },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(create_final_negotiation_dto_1.CreateFinalNegotiationDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Final negotiation meeting creation failed.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data" },
            },
        },
    }));
}
function updateOpportunityActivitiesSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(opportunity_activity_dto_1.OpportunityActivitiesDto), (0, swagger_1.ApiOperation)({
        summary: "Update multiple opportunity activities",
        description: "Update multiple opportunity activities with the provided details.",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for creating multiple opportunity activities.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(opportunity_activity_dto_1.OpportunityActivitiesDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.opportunityActivityUpdatedSuccessfully,
        type: opportunity_activity_dto_1.OpportunityActivitiesDto, // Reference the DTO here
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request - Invalid input data",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
const getOpportunityActivityByIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve opportunity activity by ID",
        description: "Fetches the details of a specific opportunity activity by its ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(opportunity_activities_dto_1.GetOpportunityActivitiesResponseDto), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Opportunity Activities retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Opportunity Activities retrieved successfully.",
                },
                data: {
                    type: "array",
                    items: { $ref: (0, swagger_1.getSchemaPath)(opportunity_activities_dto_1.GetOpportunityActivitiesResponseDto) },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Opportunity activity not found",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Opportunity activity not found",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
};
exports.getOpportunityActivityByIdSwaggerMetadata = getOpportunityActivityByIdSwaggerMetadata;
function getOpportunityActivityMetaSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Retrieve Opportunity Activity Meta",
        description: "Fetches the meta information of a specific opportunity activity by its opportunityId.",
    }), (0, swagger_1.ApiParam)({
        name: "opportunityId",
        required: true,
        description: "The ID of the opportunity.",
        example: 75,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.opportunityActivityMetaRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.opportunityActivityMetaRetrieved,
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 4 },
                            activityId: { type: "number", example: 2 },
                            activityName: { type: "string", example: "KDM Meeting" },
                            activityMeta: {
                                type: "object",
                                example: { key2: "value2" },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.opportunityActivityMetaNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.opportunityActivityMetaNotFound,
                },
            },
        },
    }));
}
function createKDMMeetingSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_kdm_meeting_dto_1.CreateKDMMeetingDto), (0, swagger_1.ApiOperation)({
        summary: "Create a KDM meeting",
        description: "Creates a KDM meeting with the provided details.",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for creating a KDM meeting.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_kdm_meeting_dto_1.CreateKDMMeetingDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "KDM meeting created successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: {
                    type: "string",
                    example: "KDM meeting created successfully.",
                },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(create_kdm_meeting_dto_1.CreateKDMMeetingDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "KDM meeting creation failed.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
const createDataValidationSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Create Data Validation for an Opportunity Activity",
        description: "Creates a new data validation record for a specific opportunity activity. This includes fields like plan date, perform date, description, and activity type.",
    }), (0, swagger_1.ApiExtraModels)(create_data_validation_dto_1.CreateDataValidationDto), // Include the DTO model explicitly
    (0, swagger_1.ApiBody)({
        description: "The data validation details to create.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_data_validation_dto_1.CreateDataValidationDto), // Reference the DTO schema
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "Successfully created the data validation record.",
        schema: {
            type: "object",
            properties: {
                id: { type: "number", example: 1 },
                opportunityId: { type: "number", example: 1 },
                activityId: { type: "number", example: 2 },
                planDate: { type: "string", example: "2025-05-14" },
                performDate: { type: "string", example: "2025-05-15" },
                description: {
                    type: "string",
                    example: "This is a sample description for the activity.",
                },
                activityTypeLid: { type: "number", example: 3 },
                createdAt: { type: "string", example: "2025-05-10T10:00:00.000Z" },
                updatedAt: { type: "string", example: "2025-05-10T10:00:00.000Z" },
                createdBy: { type: "number", example: 1 },
                updatedBy: { type: "number", example: 1 },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Failed to create data validation due to invalid input or other errors.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
                error: { type: "string", example: "Bad Request" },
            },
        },
    }));
};
exports.createDataValidationSwaggerMetadata = createDataValidationSwaggerMetadata;
const getDataValidationByOpportunityActivityIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve Data Validation by Opportunity Activity ID",
        description: "Fetches the data validation record for a specific opportunity activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        description: "The ID of the opportunity activity.",
        example: 123,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Successfully retrieved the data validation record.",
        schema: {
            type: "object",
            properties: {
                id: { type: "number", example: 1 },
                opportunityId: { type: "number", example: 1 },
                activityId: { type: "number", example: 2 },
                planDate: { type: "string", example: "2025-05-14" },
                performDate: { type: "string", example: "2025-05-15" },
                description: {
                    type: "string",
                    example: "This is a sample description for the activity.",
                },
                activityTypeLid: { type: "number", example: 3 },
                createdAt: { type: "string", example: "2025-05-10T10:00:00.000Z" },
                updatedAt: { type: "string", example: "2025-05-10T10:00:00.000Z" },
                createdBy: { type: "number", example: 1 },
                updatedBy: { type: "number", example: 1 },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Data validation record not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Data validation record not found.",
                },
                error: { type: "string", example: "Not Found" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Failed to retrieve data validation due to invalid input.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid input data.",
                },
                error: { type: "string", example: "Bad Request" },
            },
        },
    }));
};
exports.getDataValidationByOpportunityActivityIdSwaggerMetadata = getDataValidationByOpportunityActivityIdSwaggerMetadata;
const getMeetingByIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Retrieve meeting details by opportunityActivityId",
        description: "Fetches the details of a specific meeting by its ID.",
    }), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        description: "The opportunityActivityId of the Opportunity Activity",
        type: Number,
        example: 1,
    }), (0, swagger_1.ApiExtraModels)(get_metting_by_id_dto_1.GetMeetingByIdResponseDto), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Meeting details retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Meeting details retrieved successfully.",
                },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(get_metting_by_id_dto_1.GetMeetingByIdResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Meeting not found",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: "Meeting not found" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
};
exports.getMeetingByIdSwaggerMetadata = getMeetingByIdSwaggerMetadata;
function createOpportunityActivitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Create Opportunity Activity Data" }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Activity data request (choose type)",
        schema: { type: "object" },
        examples: {
            dataValidation: {
                summary: "Data Validation Activity",
                value: {
                    opportunityActivityId: 162,
                    planDate: "2025-05-14",
                    performDate: "2025-07-15",
                    description: "This is a sample description for the activity.",
                    activityTypeLid: 395,
                },
            },
            kdmMeeting: {
                summary: "KDM Meeting Activity",
                value: {
                    opportunityActivityId: 401,
                    meetingTypeLid: 444,
                    meetingDate: "2025-12-10",
                    startTime: "2025-05-10T10:00:00Z",
                    endTime: "2025-05-10T11:00:00Z",
                    location: "Conference Room A",
                    minOfMeeting: "Discussed project timelines and deliverables.",
                    remarks: "This is a detailed description of the meeting.",
                    statusLid: 450,
                    participants: [
                        { participantId: 580, participantRecordType: "TPA_CONTACT" },
                    ],
                    documents: [{ documentId: 222 }],
                },
            },
            mandateForm: {
                summary: "Mandate Form",
                value: {
                    opportunityActivityId: 181,
                    activityDate: "2025-01-31",
                    planDate: "2025-11-30",
                    mandateTypeLid: 399,
                    validFrom: "2025-01-16",
                    validTo: "2025-12-31",
                    compensationPayable: 1000,
                    compensationTypeLid: 401,
                    issuedOn: "2023-07-01",
                    remarks: "This is a sample remark for the mandate.",
                    mandateDetailsDocuments: [
                        {
                            documentTypeLid: 237,
                            documentId: 35,
                        },
                    ],
                    mandateDetailsContacts: [
                        {
                            contactId: 272,
                        },
                    ],
                },
            },
            brokingSlipDetails: {
                summary: "Broking Slip Details Activity",
                value: {
                    opportunityActivityId: 575,
                    statusLid: 403,
                    brokingSlipVersionDetails: [
                        {
                            opportunityId: 414,
                            sumInsured: 1000000,
                            versionName: "sample version",
                            brokeragePercentage: 2.5,
                            policyFrom: "2025-12-10T00:00:00.000Z",
                            policyTo: "2026-12-10T00:00:00.000Z",
                            renewalDate: "2026-12-10T00:00:00.000Z",
                            quoteReceiptTimeline: "2025-12-01T00:00:00.000Z",
                            businessActivity: "Manufacturing",
                            riskMitigationFeatures: "Fire alarms, sprinklers, CCTV surveillance",
                            clauses: "No claims made in the last 5 years.",
                            insurerRemarks: "The insurer has approved the risk assessment.",
                            remarks: "This is a high-value opportunity.",
                            preferredInsurerDetails: [
                                {
                                    insurerId: 233,
                                    locationId: 1,
                                    branchId: 1681,
                                    contactId: 579,
                                },
                            ],
                            preferredTpaDetails: [
                                {
                                    tpaId: 159,
                                    locationId: 1,
                                    branchId: 1681,
                                    contactId: 578,
                                },
                            ],
                            coverDetails: [
                                {
                                    opportunityId: 414,
                                    coverMapId: 165,
                                    policyId: 255,
                                    coverName: "Hospitalization Expenses",
                                    coverResponse: "Answer for Accidental Death Benefit",
                                },
                                {
                                    opportunityId: 414,
                                    coverMapId: 166,
                                    policyId: 255,
                                    coverName: "Disability Benefit",
                                    coverResponse: "Answer for Maturity Benefit",
                                },
                                {
                                    opportunityId: 414,
                                    coverMapId: 167,
                                    policyId: 255,
                                    coverName: "Waiver of Premium",
                                    coverResponse: "Answer for Critical Illness Cover",
                                },
                            ],
                        },
                    ],
                },
            },
            quoteEntry: {
                summary: "Quote Entry Activity",
                value: {
                    opportunityActivityId: 1511,
                    opportunityId: 123,
                    brokingSlipId: 453,
                    insurerId: 789,
                    quoteReceivedOn: "2025-05-26T10:00:00Z",
                    basicPremium: 10000,
                    terrorismCover: 2000,
                    tax: 18,
                    taxValue: 1800,
                    netPremium: 11800,
                    brokeragePercent: 10,
                    insurerRemarks: "Sample remarks for the insurer",
                    attachmentUrl: "https://example.com/quote-document.pdf",
                    statusId: 1,
                    documents: [
                        {
                            documentId: 120,
                        },
                        {
                            documentId: 121,
                        },
                    ],
                    covers: [
                        {
                            id: 121,
                            response: "test",
                        },
                    ],
                },
            },
            finalNegotiation: {
                summary: "Final Negotiation Activity",
                value: {
                    opportunityActivityId: 391,
                    meeting: {
                        meetingTypeLid: 443,
                        meetingDate: "2025-06-20",
                        startTime: "2023-10-01T10:00:00Z",
                        endTime: "2023-10-01T11:00:00Z",
                        location: "Meeting location",
                        meetingPurpose: "Discuss project updates",
                        minOfMeeting: "Minutes of the meeting are recorded here.",
                        participants: [
                            {
                                participantId: 578,
                                participantRecordType: "TPA_CONTACT",
                            },
                        ],
                        documents: [
                            {
                                documentId: 112,
                            },
                        ],
                    },
                    policyPlacedTypeId: 310,
                    leadInsurerId: 248,
                    isLeadInsurerPayCommission: true,
                    finalizedQuoteId: 19,
                    isQuoteEdited: false,
                    basicPremium: 10000,
                    terrorism: 500,
                    tax: 18,
                    taxValue: 1800,
                    netPremium: 11800,
                    brokeragePercentage: 10,
                    insurerRemarks: "Insurer remarks",
                    remarks: "General remarks",
                    sharingDetails: [
                        {
                            insurerId: 248,
                            sharePercentage: 25.5,
                            brokeragePercentage: 10,
                            brokerageAmount: 5000,
                        },
                    ],
                    qcrVariations: [
                        {
                            name: "Variation A",
                            description: "Description of the variation",
                        },
                    ],
                    slaDetails: [
                        {
                            serviceTypeId: 259,
                            numberOfDays: 30,
                        },
                    ],
                    documents: [
                        {
                            documentId: 101,
                        },
                    ],
                },
            },
            premiumCalculation: {
                summary: "Premium Calculation Activity",
                value: {
                    opportunityActivityId: 580,
                    statusLid: 403,
                    premiumCalculationDetails: {
                        "662": "This is my Commercial vessels data",
                        "663": "This is my ships",
                        "664": "This is my data",
                    },
                    remarksSection: {
                        remarks: "This is my reamrks data",
                    },
                    documents: [
                        {
                            documentTypeLid: 237,
                            documentId: 25,
                        },
                    ],
                },
            },
            rfpCoverDetail: {
                summary: "RFP Cover Detail Activity",
                value: {
                    opportunityActivityId: 573,
                    coversConfig: {
                        "165": "Answer for Accidental Death Benefit",
                        "166": "Answer for Maturity Benefit",
                        "167": "Answer for Critical Illness Cover",
                    },
                    statusLid: 403,
                    remarksSection: {
                        remarks: "testRemarks",
                    },
                    documents: [
                        {
                            documentTypeLid: 240,
                            documentId: 292,
                        },
                    ],
                },
            },
            heldCoverNote: {
                summary: "Held Cover Note Activity",
                value: {
                    opportunityActivityId: 2145,
                    statusLid: 403,
                    placementSlipDeviationsSection: {
                        placementSlipDeviationsLid: 406,
                    },
                    deviationSection: {
                        deviations: "dcsfg",
                    },
                    deviationsAddressedSection: {
                        deviationsAddressedLid: 406,
                        resolutionLid: 408,
                        revisedHeldCoverNoteLid: 406,
                    },
                    premiumReceiptDetailsSection: {
                        acknowledgedBy: 12,
                        receiptDate: "2025-10-15",
                        receiptNo: "PO-1000",
                        allDocumentsReceivedDate: "2025-10-25",
                    },
                    remarksSection: {
                        remarks: "djsk",
                    },
                    documents: [
                        {
                            documentTypeLid: 237,
                            documentId: 25,
                        },
                    ],
                },
            },
            policyHardCopy: {
                summary: "Policy Hard Copy Activity",
                value: {
                    opportunityActivityId: 786,
                    statusLid: 403,
                    insurerPolicyHardCopyDetails: {
                        insurerPolicyNo: "Insurer Policy-PO001",
                        hardCopyReceivedOn: "2025-05-21",
                    },
                    deviationSection: {
                        deviationsLid: 406,
                        premium: "300",
                        brokeragePercentage: "15%",
                        brokerageAmount: "45556",
                        deviationCoveragesLid: 406,
                        coverages: "coverages data",
                        exclusions: "exclusions data",
                        deductibles: "deductibles data ",
                    },
                    deviationsAddressedSection: {
                        deviationsAddressedLid: 406,
                        policyHardCopyReceivedLid: 406,
                        resolutionLid: null,
                        remarks: "remarks data",
                    },
                    documents: [
                        {
                            documentTypeLid: 237,
                            documentId: 117,
                        },
                    ],
                },
            },
            policyConfirmation: {
                summary: "Policy Confirmation Activity",
                value: {
                    opportunityActivityId: 501,
                    statusLid: 403,
                    policyDataWrongSection: {
                        policyDataWrongLid: 406,
                        deviationResolvedLid: 405,
                        comments: "Need to verify with underwriting team",
                    },
                    deviationSection: {
                        deviations: "Enter deviations",
                    },
                    policyDataRectifiedSection: {
                        policyDataRectifiedLid: 406,
                        resolutionLid: 408,
                        remarks: "Remarks data",
                    },
                    documents: [
                        {
                            documentTypeLid: 237,
                            documentId: 25,
                        },
                    ],
                },
            },
            policyDocket: {
                summary: "Policy Docket Activity",
                value: {
                    opportunityActivityId: 617,
                    statusLid: 403,
                    placementSlipDetailsSection: {
                        issuanceDate: "2025-05-14",
                    },
                    serviceLevelAgreementSection: {
                        heldCoverNote: 1,
                        policyDocument: 20,
                        policyDocket: 5,
                        endorsement: 3,
                        healthClaims: 5,
                        nonHealthClaims: 2,
                        mir: 1,
                        monthlyMeeting: 4,
                        quarterlyMeeting: 6,
                        renewalNotice: 8,
                        dataCollection: 0,
                        remarks: "Policy Docket",
                    },
                    documents: [
                        {
                            documentTypeLid: 237,
                            documentId: 51,
                        },
                    ],
                },
            },
            HandOverMeet: {
                summary: "Hand Over Meet Activity",
                value: {
                    opportunityActivityId: 754,
                    meetingDate: "2025-12-10",
                    startTime: "2025-05-10T10:00:00Z",
                    endTime: "2025-05-10T11:00:00Z",
                    meetingTypeLid: 444,
                    location: "Conference Room A",
                    minutesOfMeeting: "Discussed project timelines and deliverables.",
                    remarks: "This is a detailed description of the meeting.",
                    statusLid: 403,
                    participants: [
                        {
                            participantRecordType: "INSURER_CONTACT",
                            participantId: 637,
                        },
                    ],
                    documents: [
                        {
                            documentTypeLid: 237,
                            documentId: 35,
                        },
                    ],
                },
            },
            rfpDeatilsentry: {
                summary: "Rfp details Entry Activity",
                value: {
                    opportunityActivityId: 2019,
                    descriptionRequirements: {
                        description: "Sample description",
                        requirements: "Sample requirements",
                    },
                    preferredInsurers: [
                        {
                            insurerId: 361,
                            locationId: 2,
                            branchId: 1,
                            contactId: 2,
                        },
                    ],
                    excludedInsurers: [
                        {
                            insurerId: 358,
                            locationId: 4,
                            branchId: 1,
                            contactId: 934,
                        },
                    ],
                    preferredTPA: [
                        {
                            tpaId: 204,
                            locationId: 2,
                            branchId: 1,
                            contactId: null,
                        },
                    ],
                    excludedTPA: [
                        {
                            tpaId: 205,
                            locationId: 3,
                            branchId: 1,
                            contactId: 1,
                        },
                    ],
                    dynamicQuote: {
                        multipleBrokerInvolved: 1,
                        isMarketAllocationDone: 1,
                    },
                    clientContactDetails: {
                        contactId: 949,
                        decisionInfluencers: [1, 2],
                        expectedPremium: 76,
                    },
                    creditSharing: [
                        {
                            executiveId: 2,
                            percentage: 213,
                        },
                    ],
                    targetQcrDate: {
                        targetQcrDate: "2025-06-26",
                    },
                    clientConsiderations: {
                        clientConsiderations: "Sample considerations",
                        threatsFromExistingInsurer: "Sample threats from insurer",
                        threatsFromExistingBroker: "Sample threats from broker",
                        extraneousFactors: "extraneous Factors",
                        planForClosingDetail: "Sample closing plan",
                    },
                    remarks: {
                        remarks: "Sample remarks",
                    },
                    documents: [
                        {
                            documentId: 802,
                            documentTypeLid: 240,
                        },
                    ],
                    statusLid: 403,
                },
            },
            placementSlip: {
                summary: "Placement Slip Activity",
                value: {
                    opportunityActivityId: 1693,
                    statusLid: 357,
                    policyDetails: {
                        policyFromDate: "2025-06-12",
                        policyToDate: "2025-06-16",
                        sumInsured: 15000,
                        basicPremium: 789,
                        isPremiumInstallmentBased: 399,
                    },
                    installmentDates: [
                        {
                            firstInstallmentDate: "2025-06-06",
                            secondInstallmentDate: "2025-06-13",
                        },
                        {
                            firstInstallmentDate: "2025-06-14",
                            secondInstallmentDate: "2025-06-21",
                        },
                    ],
                    feeDetails: {
                        fee: 46,
                        isFeeInInstallment: 399,
                        terrorismCommissionPercentage: 78,
                        serviceTaxPercentage: 78,
                        serviceTaxAmount: 90,
                        other: "90",
                        totalPremium: 79,
                        placementSlipDate: "2025-06-12",
                    },
                    insurerDetails: [
                        {
                            insurerId: 373,
                            insurerLocationId: 46,
                            insurerBranchId: 2978,
                            insurerContactId: 915,
                        },
                    ],
                    tpaDetails: [
                        {
                            tpaId: 221,
                            tpaLocationId: 46,
                            tpaBranchId: 2845,
                            tpaContactId: 952,
                        },
                    ],
                    otherDeatils: {
                        leadInsurerId: 373,
                        isLeadInsurerPayCommission: 399,
                        maxAgeOfDependents: 60,
                        brokeragePercentage: 99,
                        policyPlacedTypeLid: 341,
                    },
                    insurerAndBrokeragePercentage: [
                        {
                            insurerId: 373,
                            sharePercentage: 28,
                            brokeragePercentage: 89,
                            brokerageAmount: 90,
                        },
                    ],
                    cdAccountDetails: {
                        paymentTypeLid: 444,
                        cdAccountTypeLid: 442,
                        accountName: "Saving Account",
                        openBalance: 78,
                        selectCdAccount: 442,
                        transactionTypeLid: 440,
                        chequeDate: "2025-06-14",
                        chequeAmount: 890,
                        chequeNumber: "101022",
                        bankName: "HDFC Bank",
                    },
                    coverDetails: {},
                    remarks: {
                        remarks: "no remarks",
                    },
                    documents: [
                        {
                            documentId: 123,
                            documentTypeLid: 237,
                        },
                    ],
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Opportunity Activity saved successfully",
    }), (0, swagger_1.ApiResponse)({ status: 404, description: "Activity meta not found" }), (0, swagger_1.ApiResponse)({ status: 400, description: "Bad Request" }));
}
const updateKDMMeetingSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update KDM Meeting",
        description: "This endpoint allows updating an existing KDM meeting record by its ID. The request body accepts partial updates for the KDM meeting fields.",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        type: Number,
        description: "The ID of the KDM meeting record to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_kdm_meeting_dto_1.UpdateKDMMeetingDto), // Include the DTO model explicitly
    (0, swagger_1.ApiBody)({
        description: "The KDM meeting details to update.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_kdm_meeting_dto_1.UpdateKDMMeetingDto), // Reference the DTO schema
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "KDM meeting updated successfully.",
        schema: {
            example: {
                statusCode: 200,
                message: "KDM meeting updated successfully.",
                data: {
                    id: 1,
                    meetingDate: "2025-05-14",
                    description: "Updated description for the KDM meeting.",
                    participants: [{ participantId: 101 }, { participantId: 102 }],
                    documents: [{ documentId: 201 }, { documentId: 202 }],
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "KDM meeting not found.",
        schema: {
            example: {
                statusCode: 404,
                message: "KDM meeting not found.",
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request.",
        schema: {
            example: {
                statusCode: 400,
                message: "Failed to update KDM meeting.",
            },
        },
    }));
};
exports.updateKDMMeetingSwaggerMetadata = updateKDMMeetingSwaggerMetadata;
const updateHandOverMeetingSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update Hand Over Meeting",
        description: "This endpoint allows updating an existing Hand Over meeting record by its ID. The request body accepts partial updates for the Hand Over meeting fields.",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        type: Number,
        description: "The Meeting ID of the Hand over meeting record to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "The Hand Over meeting details to update.",
        schema: {
            type: "object",
            properties: {
                meetingDate: { type: "string", example: "2025-12-12" },
                startTime: { type: "string", example: "2025-05-10T11:00:00Z" },
                endTime: { type: "string", example: "2025-05-10T12:00:00Z" },
                remarks: {
                    type: "string",
                    example: "Updated remarks for the handover meeting.",
                },
                location: { type: "string", example: "Conference Room B" },
                meetingTypeLid: { type: "number", example: 444 },
                minutesOfMeeting: {
                    type: "string",
                    example: "Discussed project timelines and deliverables.",
                },
                participants: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            participantId: { type: "number", example: 578 },
                            participantRecordType: {
                                type: "string",
                                example: "TPA_CONTACT",
                            },
                        },
                    },
                },
                documents: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            documentTypeLid: { type: "number", example: 237 },
                            documentId: { type: "number", example: 333 },
                        },
                    },
                },
                statusLid: { type: "number", example: 403 },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Hand Over meeting updated successfully.",
        schema: {
            example: {
                statusCode: 200,
                message: "Hand Over meet updated successfully.",
                data: {
                    meetingId: { type: "number", example: 203 },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Hand Over meet not found.",
        schema: {
            example: {
                statusCode: 404,
                message: "Hand Over meet not found.",
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request.",
        schema: {
            example: {
                statusCode: 400,
                message: "Failed to update Hand Over meeting.",
            },
        },
    }));
};
exports.updateHandOverMeetingSwaggerMetadata = updateHandOverMeetingSwaggerMetadata;
function getRfpDataByOpportunityIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve RFP data by Opportunity Activity ID",
        description: "Fetches the RFP data associated with a specific Opportunity Activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        type: Number,
        required: true,
        description: "The ID of the Opportunity Activity for which RFP data is to be retrieved.",
        example: 123,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "RFP data retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "RFP data retrieved successfully.",
                },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        name: { type: "string", example: "Sample RFP" },
                        description: {
                            type: "string",
                            example: "Details about the RFP",
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "RFP data not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "RFP data not found.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid Opportunity Activity ID.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid Opportunity Activity ID.",
                },
            },
        },
    }));
}
function getOpportunityCoversMetaSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve Opportunity Covers Metadata",
        description: "Fetches the metadata of covers associated with a specific Opportunity ID and optional Activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityId",
        type: Number,
        required: true,
        description: "The ID of the Opportunity for which covers metadata is to be retrieved.",
        example: 123,
    }), (0, swagger_1.ApiQuery)({
        name: "activityId",
        type: Number,
        required: false,
        description: "The optional Activity ID to filter the covers metadata.",
        example: 456,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Covers metadata retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Covers metadata retrieved successfully.",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 1 },
                            name: { type: "string", example: "Cover Name" },
                            description: { type: "string", example: "Cover Description" },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Covers metadata not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Covers metadata not found.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid Opportunity ID or Activity ID.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid Opportunity ID or Activity ID.",
                },
            },
        },
    }));
}
function createMandateSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Create a mandate",
        description: "Creates a new mandate for an opportunity activity.",
    }), (0, swagger_1.ApiExtraModels)(create_mandate_details_dto_1.CreateMandateDto), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Details required to create a mandate.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_mandate_details_dto_1.CreateMandateDto), // Reference the DTO schema
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "Mandate created successfully.",
        type: create_mandate_details_dto_1.CreateMandateDto,
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Not Found. Opportunity activity not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal Server Error. Failed to create mandate.",
    }));
}
function getMandateDetailsByOpportunityActivityIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve mandate details by Opportunity Activity ID",
        description: "Fetches the mandate details associated with a specific Opportunity Activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        type: Number,
        required: true,
        description: "The ID of the Opportunity Activity",
        example: 181,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Mandate details retrieved successfully.",
        type: create_mandate_details_dto_1.CreateMandateDto,
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Mandate details not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
    }));
}
function getPolicyDocketByOpportunityActivityIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve Policy Docket by Opportunity Activity ID",
        description: "Fetches the policy docket details for a specific opportunity activity ID, including related documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        description: "The ID of the opportunity activity.",
        required: true,
        example: 753,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Policy docket retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Policy docket retrieved successfully",
                },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        opportunityId: { type: "number", example: 425 },
                        activityId: { type: "number", example: 30 },
                        opportunityActivityId: { type: "number", example: 753 },
                        statusLid: { type: "number", example: 403 },
                        issuanceDate: { type: "string", example: "2025-10-10" },
                        heldCoverNote: { type: "number", example: 1 },
                        policyDocument: { type: "number", example: 20 },
                        policyDocket: { type: "number", example: 5 },
                        endorsement: { type: "number", example: 3 },
                        healthClaims: { type: "number", example: 5 },
                        nonHealthClaims: { type: "number", example: 2 },
                        mir: { type: "number", example: 1 },
                        monthlyMeeting: { type: "number", example: 4 },
                        quarterlyMeeting: { type: "number", example: 6 },
                        renewalNotice: { type: "number", example: 8 },
                        dataCollection: { type: "number", example: 0 },
                        remarks: { type: "string", example: "Policy Docket remarks" },
                        documents: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 3 },
                                    policyDocketId: { type: "number", example: 1 },
                                    documentId: { type: "number", example: 26 },
                                    documentTypeLid: { type: "number", example: 238 },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({ status: 404, description: "Activity data not found" }), (0, swagger_1.ApiResponse)({ status: 400, description: "Bad Request" }));
}
function getOpportunityActivitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Get Opportunity Activity Data" }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        type: Number,
        required: true,
        description: "The ID of the Opportunity Activity",
        example: 181,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Opportunity Activity retrieve successfully",
        examples: {
            dataValidation: {
                summary: "Data Validation Activity",
                value: {
                    id: 42,
                    opportunityId: 430,
                    activityId: 17,
                    statusLid: 403,
                    dataActivity: {
                        remarks: {
                            description: "This is a sample description for the activity.",
                        },
                        documents: [
                            {
                                id: 1,
                                documentId: 222,
                                documentTypeLid: 237,
                            },
                        ],
                    },
                },
            },
            kdmMeeting: {
                summary: "KDM Meeting Activity",
                value: {
                    id: 112,
                    meetingDate: "2025-12-10",
                    startTime: "2025-05-10T10:00:00.000Z",
                    endTime: "2025-05-10T11:00:00.000Z",
                    location: "Conference Room B at 10:00 AM",
                    minOfMeeting: "Discussed ravi kirab is a project one tho the project timelines and deliverables.",
                    activityStatus: "Submitted",
                    description: "This is a detailed description of the meeting.",
                    meetingId: 111,
                    company: {
                        id: 834,
                        name: "divami1223",
                    },
                    opportunity: {
                        id: 404,
                    },
                    meetingType: {
                        id: 343,
                        name: "Introductory Call",
                    },
                    participants: [
                        {
                            id: 164,
                            participantRecordType: "TPA_CONTACT",
                        },
                    ],
                },
            },
            mandateForm: {
                summary: "Mandate Form Activity",
                value: {
                    id: 46,
                    opportunityId: 401,
                    activityId: 19,
                    statusLid: 404,
                    dataActivity: {
                        mandateDetailsFromFields: {
                            mandateTypeLid: 330,
                            validFrom: "2025-05-29",
                            validTo: "2025-12-31",
                            compensationPayable: 1000,
                            compensationTypeLid: 401,
                            issuedOn: "2025-05-19",
                            remarks: "This is a sample added due to ravis decision remark for the mandate.",
                            mandateDetailsContacts: [573],
                        },
                        documents: [
                            {
                                id: 23,
                                documentId: 35,
                                documentTypeLid: 237,
                            },
                            {
                                id: 24,
                                documentId: 29,
                                documentTypeLid: 237,
                            },
                        ],
                    },
                },
            },
            premiumCalculation: {
                summary: "Premium Calculation Activity",
                value: {
                    opportunityActivityId: 580,
                    statusLid: 403,
                    dataActivity: {
                        premiumCalculationDetails: {
                            "662": "This is my Commercial vessels data",
                            "663": "This is my ships",
                            "664": "This is my data",
                        },
                        remarksSection: {
                            remarks: "This is my reamrks data",
                        },
                        documents: [
                            {
                                id: 9,
                                documentTypeLid: 237,
                                documentId: 25,
                            },
                            {
                                id: 10,
                                documentTypeLid: 237,
                                documentId: 25,
                            },
                            {
                                id: 11,
                                documentTypeLid: 237,
                                documentId: 25,
                            },
                            {
                                id: 12,
                                documentTypeLid: 237,
                                documentId: 25,
                            },
                        ],
                    },
                },
            },
            heldCoverNote: {
                summary: "Held Cover Note Activity",
                value: {
                    id: 14,
                    opportunityActivityId: 462,
                    statusLid: 403,
                    dataActivity: {
                        placementSlipDeviationsSection: {
                            placementSlipDeviationsLid: 406,
                        },
                        deviationSection: {
                            deviations: "deviations data",
                        },
                        deviationsAddressedSection: {
                            deviationsAddressedLid: 406,
                            resolutionLid: null,
                            revisedHeldCoverNoteLid: 406,
                        },
                        premiumReceiptDetailsSection: {
                            acknowledgedBy: null,
                            receiptNo: "PO-1000",
                            receiptDate: "2025-10-15T00:00:00.000Z",
                            allDocumentsReceivedDate: "2025-10-25T00:00:00.000Z",
                        },
                        remarksSection: {
                            remarks: "remarks data",
                        },
                        documents: [
                            {
                                id: 40,
                                documentId: 45,
                                documentTypeLid: 237,
                            },
                        ],
                    },
                },
            },
            policyConfirmation: {
                summary: "Policy Confirmation Activity",
                value: {
                    id: 9,
                    opportunityActivityId: 467,
                    statusLid: 404,
                    dataActivity: {
                        policyDataWrongSection: {
                            policyDataWrongLid: 406,
                            deviationResolvedLid: 405,
                            comments: "Need to verify with underwriting team",
                        },
                        deviationSection: {
                            deviations: "enter deviations",
                        },
                        policyDataRectifiedSection: {
                            policyDataRectifiedLid: 406,
                            resolutionLid: 408,
                            remarks: "remarks data",
                        },
                        documents: [
                            {
                                id: 2,
                                documentTypeLid: 237,
                                documentId: 25,
                            },
                        ],
                    },
                },
            },
            policyHardCopy: {
                summary: "Policy Hard Copy Activity",
                value: {
                    id: 4,
                    opportunityActivityId: 786,
                    statusLid: 403,
                    dataActivity: {
                        insurerPolicyHardCopyDetails: {
                            insurerPolicyNo: "Insurer Policy-PO001",
                            hardCopyReceivedOn: "2025-05-21",
                        },
                        deviationSection: {
                            deviationsLid: 406,
                            premium: "300",
                            brokeragePercentage: "15%",
                            brokerageAmount: null,
                            deviationCoveragesLid: 406,
                            coverages: "coverages data",
                            exclusions: "exclusions data",
                            deductibles: "deductibles data ",
                        },
                        deviationsAddressedSection: {
                            deviationsAddressedLid: 406,
                            policyHardCopyReceivedLid: 406,
                            resolutionLid: null,
                            remarks: "remarks data",
                        },
                        documents: [
                            {
                                id: 10,
                                documentId: 117,
                                documentTypeLid: 237,
                            },
                        ],
                    },
                },
            },
            policyDocket: {
                summary: "Policy Docket Activity",
                value: {
                    id: 6,
                    opportunityActivityId: 617,
                    statusLid: 403,
                    dataActivity: {
                        placementSlipDetailsSection: {
                            issuanceDate: "2025-05-14",
                        },
                        serviceLevelAgreementSection: {
                            heldCoverNote: 1,
                            policyDocument: 20,
                            policyDocket: 5,
                            endorsement: 3,
                            healthClaims: 5,
                            nonHealthClaims: 2,
                            mir: 1,
                            monthlyMeeting: 4,
                            quarterlyMeeting: 6,
                            renewalNotice: 8,
                            dataCollection: 0,
                            remarks: "Policy Docket",
                        },
                        documents: [
                            {
                                id: 12,
                                documentId: 51,
                                documentTypeLid: 237,
                            },
                        ],
                    },
                },
            },
            handOverMeet: {
                summary: "Hand Over Meet Activity",
                value: {
                    id: 3,
                    activityId: 31,
                    opportunityId: 417,
                    opportunityActivityId: 618,
                    remarks: "This is a detailed description of the meeting.",
                    meetingId: 206,
                    statusLid: 403,
                    meeting: {
                        opportunityId: 417,
                        activityId: 618,
                        meetingTypeLid: 444,
                        meetingSubTypeLid: 449,
                        companyId: 834,
                        contactId: null,
                        meetingDate: "2025-12-10",
                        startTime: "2025-05-10T10:00:00.000Z",
                        endTime: "2025-05-10T11:00:00.000Z",
                        location: "Conference Room A",
                        minOfMeeting: "Discussed project timelines and deliverables.",
                        meetingPurpose: null,
                        meetingAgenda: null,
                        id: 206,
                        participants: [
                            {
                                meetingId: 206,
                                participantId: 637,
                                participantRecordType: "INSURER_CONTACT",
                                id: 100,
                            },
                        ],
                        company: {
                            companyName: "divami",
                            displayName: "divami1223",
                            companyTypeLid: 324,
                            currencyId: 113,
                            industrySegmentLid: 214,
                            noOfEmployees: 657,
                            website: "http://example.com",
                            dateOfIncorporation: "2025-05-19",
                            panCardNumber: "BUVPV9741D",
                            registrationNo: "U12345AB1234PLC123456",
                            annualPremium: "34567.00",
                            tanNumber: "PDES03098F",
                            priorityLid: 53,
                            remarks: "<p>adasdadasdasdadasdasd</p>",
                            statusLid: 32,
                            groupCompanyLid: 47,
                            sentimentLid: 301,
                            sourceTypeLid: 294,
                            source: "Some source",
                            leadCrm: 1,
                            accountManager: 91,
                            countryId: 1,
                            id: 834,
                            country: {
                                name: "India",
                                isoCode: null,
                                id: 1,
                            },
                        },
                        opportunity: {
                            opportunityId: 417,
                            companyId: 834,
                            contactId: null,
                            estimatedBrokerage: 1000,
                            policyTypeLid: 255,
                            policyStatusLid: 257,
                            serviceLevelLid: 259,
                            soExpireDate: "2026-12-31",
                            sumInsured: 500000,
                            premiumPaid: 20000,
                            stageLid: null,
                            referredBy: null,
                            sharingPercentage: null,
                            estimatedFee: 500,
                            prevInsurerId: null,
                            prevInsurerLocationId: null,
                            prevInsurerBranchId: null,
                            prevTpaId: null,
                            prevTpaLocationId: null,
                            prevTpaBranchId: null,
                            remarks: null,
                            opportunityTypeLid: 312,
                            isPolicyMinedLid: 310,
                            source: "Some source",
                            opportunitySourceTypeLid: 303,
                            salesPitch: "This is a sales pitch",
                        },
                        meetingType: {
                            id: 444,
                            lookUpValue: "Client Meeting",
                        },
                        meetingSubType: {
                            id: 449,
                            lookUpValue: "Hand Over Meet",
                        },
                        meetingDocs: [
                            {
                                meetingId: 206,
                                documentId: 35,
                                id: 15,
                            },
                        ],
                    },
                    status: {
                        id: 403,
                        lookUpValue: "In Progress",
                    },
                },
            },
            rfpDetailsEntry: {
                summary: "Rfp Details Entry Activity",
                value: {
                    status: 200,
                    message: "Opportunity activity details retrieved successfully",
                    data: {
                        opportunityActivityId: 455,
                        descriptionRequirements: {
                            description: "This is a sample RFP details entry description.",
                            requirements: "Sample requirements for the RFP.",
                        },
                        preferredInsurers: [
                            {
                                insurerId: 242,
                                locationId: 7,
                                branchId: 1,
                                contactId: 668,
                            },
                        ],
                        excludedInsurers: [
                            {
                                insurerId: 242,
                                locationId: 4,
                                branchId: 1,
                                contactId: 668,
                            },
                        ],
                        preferredTPA: [
                            {
                                tpaId: 160,
                                locationId: 2,
                                branchId: 1,
                                contactId: 604,
                            },
                        ],
                        excludedTPA: [
                            {
                                tpaId: 160,
                                locationId: 1,
                                branchId: 1,
                                contactId: 604,
                            },
                        ],
                        dynamicQuote: {
                            multipleBrokerInvolved: 1,
                            isMarketAllocationDone: 1,
                        },
                        clientContactDetails: {
                            contactId: null,
                            decisionInfluencers: [],
                            expectedPremium: null,
                        },
                        creditSharing: [
                            {
                                executiveId: 701,
                                percentage: "50.50",
                            },
                            {
                                executiveId: 702,
                                percentage: "49.50",
                            },
                        ],
                        targetQcrDate: {
                            targetQcrDate: "2023-10-15",
                        },
                        clientConsiderations: {
                            clientConsiderations: "Client expects high-quality coverage and timely service.",
                            threatsFromExistingInsurer: "Existing insurer has strong ties with the client.",
                            threatsFromExistingBroker: null,
                            extraneousFactors: "Economic conditions may influence the decision.",
                            planForClosingDetail: "Our strategy is to offer competitive pricing and better service.",
                        },
                        remarks: {
                            remarks: "Additional remarks for the RFP details entry.",
                        },
                        documents: [
                            {
                                documentId: 801,
                                documentTypeLid: 240,
                            },
                            {
                                documentId: 802,
                                documentTypeLid: 240,
                            },
                        ],
                        statusLid: 403,
                    },
                },
            },
            placementSlip: {
                summary: "Placement Slip Activity",
                value: {
                    id: 3,
                    opportunityActivityId: 1693,
                    statusLid: 357,
                    dataActivity: {
                        policyDetails: {
                            policyFromDate: "2025-06-12",
                            policyToDate: "2025-06-16",
                            sumInsured: "15000",
                            basicPremium: "789",
                            isPremiumInstallmentBased: 399,
                        },
                        installmentDates: [
                            {
                                placementSlipId: 3,
                                firstInstallmentDate: "2025-06-06",
                                secondInstallmentDate: "2025-06-13",
                                id: 3,
                            },
                            {
                                placementSlipId: 3,
                                firstInstallmentDate: "2025-06-14",
                                secondInstallmentDate: "2025-06-21",
                                id: 4,
                            },
                        ],
                        feeDetails: {
                            fee: "46",
                            isFeeInInstallment: 399,
                            terrorismCommissionPercentage: "78",
                            serviceTaxPercentage: "78",
                            serviceTaxAmount: "90",
                            other: "90",
                            totalPremium: "79",
                            placementSlipDate: "2025-06-12",
                        },
                        otherDeatils: {
                            leadInsurerId: 373,
                            isLeadInsurerPayCommission: 399,
                            maxAgeOfDependents: 60,
                            brokeragePercentage: "99",
                            policyPlacedTypeLid: 341,
                        },
                        remarks: {
                            remarks: "no remarks",
                        },
                        tpaDetails: [
                            {
                                id: 2,
                                placementSlipId: 3,
                                tpaId: 221,
                                tpaLocationId: 46,
                                tpaBranchId: 2845,
                                tpaContactId: 952,
                            },
                        ],
                        insurerDetails: [
                            {
                                id: 2,
                                placementSlipId: 3,
                                insurerId: 373,
                                insurerLocationId: 46,
                                insurerBranchId: 2978,
                                insurerContactId: 915,
                            },
                        ],
                        insurerAndBrokeragePercentage: [
                            {
                                id: 2,
                                placementSlipId: 3,
                                insurerId: 373,
                                sharePercentage: "28",
                                brokeragePercentage: "89",
                                brokerageAmount: "90",
                            },
                        ],
                        cdAccountDetails: {
                            id: 2,
                            placementSlipId: 3,
                            paymentTypeLid: 444,
                            cdAccountTypeLid: 442,
                            accountName: "Saving Account",
                            openBalance: "78.00",
                            selectCdAccount: "442.00",
                            transactionTypeLid: 440,
                            chequeDate: "2025-06-14",
                            chequeAmount: "890",
                            chequeNumber: "101022",
                            bankName: "HDFC Bank",
                        },
                        coverDetails: {},
                        documents: [
                            {
                                documentId: 123,
                                documentTypeLid: 237,
                                id: 2,
                            },
                        ],
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid Opportunity Activity ID.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid Opportunity Activity ID.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updatePolicyDocketByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update Policy Docket by ID",
        description: "Updates the policy docket details for a specific policy docket ID, including related documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the policy docket to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating a policy docket.",
        schema: {
            type: "object",
            properties: {
                opportunityActivityId: { type: "number", example: 753 },
                statusLid: { type: "number", example: 403 },
                issuanceDate: { type: "string", example: "2025-10-10" },
                heldCoverNote: { type: "number", example: 1 },
                policyDocument: { type: "number", example: 20 },
                policyDocket: { type: "number", example: 5 },
                endorsement: { type: "number", example: 3 },
                monthlyMeeting: { type: "number", example: 4 },
                quarterlyMeeting: { type: "number", example: 6 },
                renewalNotice: { type: "number", example: 8 },
                dataCollection: { type: "number", example: 0 },
                remarks: { type: "string", example: "Policy Docket " },
                documents: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 3, nullable: true },
                            documentId: { type: "number", example: 26 },
                            documentTypeLid: { type: "number", example: 238 },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Policy docket updated successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Policy docket updated successfully",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Policy docket not found.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Policy docket not found for the given ID.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid input data.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updateQuoteSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update a Quote",
        description: "Updates an existing quote and its associated documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_quote_entry_dto_1.CreateQuoteDto), // Register CreateQuoteDto as an extra model
    (0, swagger_1.ApiParam)({
        name: "quoteId",
        type: Number,
        description: "The ID of the quote to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Details required to update a quote.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_quote_entry_dto_1.CreateQuoteDto), // Reference the DTO schema
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote updated successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Quote updated successfully." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Quote not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: "Quote not found." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal Server Error. Failed to update quote.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updateOpportunityQuoteByActivityIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update Opportunity Quote by Activity",
        description: "Updates quote remarks, status and documents using opportunity activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_quote_entry_dto_1.CreateQuoteDto), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        type: Number,
        description: "Opportunity Activity ID associated with the quote.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Details required to update opportunity quote.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_quote_entry_dto_1.CreateQuoteDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote updated successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Quote updated successfully." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Quote not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: "Quote not found." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal Server Error. Failed to update quote.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getQuoteByBrokingSlipAndActivitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a Quote by Broking Slip ID and Opportunity Activity ID",
        description: "Fetches a quote based on the provided Broking Slip ID and Opportunity Activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "brokingSlipId",
        type: Number,
        required: true,
        description: "The ID of the Broking Slip.",
        example: 123,
    }), (0, swagger_1.ApiQuery)({
        name: "opportunityActivityId",
        type: Number,
        required: true,
        description: "The ID of the Opportunity Activity.",
        example: 456,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Quote retrieved successfully." },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        brokingSlipId: { type: "number", example: 123 },
                        opportunityActivityId: { type: "number", example: 456 },
                        insurerId: { type: "number", example: 789 },
                        basicPremium: { type: "number", example: 10000 },
                        netPremium: { type: "number", example: 12000 },
                        statusId: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Quote not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: "Quote not found." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal Server Error. Failed to retrieve quote.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getQuotesByBrokingSlipSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve Quotes by Broking Slip ID",
        description: "Fetches all quotes mapped to the provided Broking Slip ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "brokingSlipId",
        type: Number,
        required: true,
        description: "The ID of the Broking Slip.",
        example: 123,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Quote retrieved successfully." },
                data: { type: "array", items: { type: "object" } },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Quote not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: "Quote not found." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal Server Error. Failed to retrieve quote.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updateHeldCoverNoteByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiExtraModels)(update_held_cover_note_dto_1.UpdateHeldCoverNoteDto), (0, swagger_1.ApiOperation)({
        summary: "Update Held Cover Note by ID",
        description: "Updates the Held Cover Note details for a specific Id, including related documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the Held Cover Note to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating an Held Cover Note",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_held_cover_note_dto_1.UpdateHeldCoverNoteDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Held Cover Note updated successfully",
        schema: {
            allOf: [
                {
                    properties: {
                        status: { type: "number", example: 200 },
                        message: {
                            type: "string",
                            example: "Held Cover Note updated successfully",
                        },
                        data: { $ref: (0, swagger_1.getSchemaPath)(update_held_cover_note_dto_1.UpdateHeldCoverNoteDto) },
                    },
                },
            ],
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Held Cover Note not found.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Held Cover Note not found for the given ID.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid input data.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updatePolicyConfirmationByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiExtraModels)(update_policy_confirmation_dto_1.UpdatePolicyConfirmationDto), (0, swagger_1.ApiOperation)({
        summary: "Update Policy Confirmation by ID",
        description: "Updates the Policy Confirmation details for a specific Id, including related documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the Policy Confirmation to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating an Policy Confirmation",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_policy_confirmation_dto_1.UpdatePolicyConfirmationDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Policy Confirmation updated successfully",
        schema: {
            allOf: [
                {
                    properties: {
                        status: { type: "number", example: 200 },
                        message: {
                            type: "string",
                            example: "Policy Confirmation updated successfully",
                        },
                        data: { $ref: (0, swagger_1.getSchemaPath)(update_policy_confirmation_dto_1.UpdatePolicyConfirmationDto) },
                    },
                },
            ],
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Policy Confirmation not found.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Policy Confirmation not found for the given ID.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid input data.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updatePolicyHardCopyByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiExtraModels)(update_policy_hard_copy_dto_1.UpdatePolicyHardCopyDto), (0, swagger_1.ApiOperation)({
        summary: "Update Policy Hard Copy by ID",
        description: "Updates the Policy Hard Copy details for a specific Id, including related documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the Policy Hard Copy to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating an Policy Hard Copy",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_policy_hard_copy_dto_1.UpdatePolicyHardCopyDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Policy Hard Copy updated successfully",
        schema: {
            allOf: [
                {
                    properties: {
                        status: { type: "number", example: 200 },
                        message: {
                            type: "string",
                            example: "Policy Hard Copy updated successfully",
                        },
                        data: { $ref: (0, swagger_1.getSchemaPath)(update_policy_hard_copy_dto_1.UpdatePolicyHardCopyDto) },
                    },
                },
            ],
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Policy Hard Copy not found.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Policy Hard Copy not found for the given ID.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid input data.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updateFinalNegotiationActivitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update Final Negotiation Activity",
        description: "Updates an existing final negotiation activity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "The ID of the final negotiation activity to update.",
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating final negotiation activity.",
        type: update_final_negotiation_activity_dto_1.UpdateFinalNegotiationActivityDto,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.finalNegotiationActivityUpdated,
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad request.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Resource not found.",
    }));
}
function getFinalNegotiationActivitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get Final Negotiation Activity",
        description: "Retrieves a final negotiation activity by ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "The ID of the final negotiation activity to retrieve.",
        example: 1,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.finalNegotiationActivityRetrieved,
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Resource not found.",
    }));
}
function createFinalNegotiationActivitySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Create Final Negotiation Activity",
        description: "Creates a new final negotiation activity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Payload for creating final negotiation activity.",
        type: create_final_negotiation_activity_dto_1.CreateFinalNegotiationActivityDto,
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.finalNegotiationActivityCreated,
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad request.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Resource not found.",
    }));
}
function getOpportunitiesByCompanyIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get Opportunities by Company ID",
        description: "Retrieves a list of opportunities associated with a specific company ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "companyId",
        type: Number,
        required: true,
        description: "The ID of the company whose opportunities are to be retrieved.",
    }), (0, swagger_1.ApiQuery)({
        name: "page",
        type: Number,
        required: false,
        description: "The page number for pagination. Default is 1.",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        type: Number,
        required: false,
        description: "The number of records per page for pagination. Default is 10.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Successfully retrieved the list of opportunities.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No opportunities found for the provided company ID.",
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad request due to invalid input or missing parameters.",
    }));
}
const getAllBrokingSlipVersionsSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiExtraModels)(qcr_broking_slip_version_details_dto_1.BrokingSlipVersionDetailDto), (0, swagger_1.ApiOperation)({
        summary: "Retrieve broking slip versions by Opportunity Activity ID",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        description: "The ID of the opportunity activity",
        type: Number,
        required: true,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.brokeingSlipVersionsRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.brokeingSlipVersionsRetrieved,
                },
                data: {
                    type: "array",
                    items: { $ref: (0, swagger_1.getSchemaPath)(qcr_broking_slip_version_details_dto_1.BrokingSlipVersionDetailDto) },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.brokingSlipVersionsNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.brokingSlipVersionsNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
};
exports.getAllBrokingSlipVersionsSwaggerMetadata = getAllBrokingSlipVersionsSwaggerMetadata;
function createPlacementSlipSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_placement_slip_dto_1.CreatePlacementSlipDto), (0, swagger_1.ApiOperation)({
        summary: "Create Placement Slip",
        description: "Creates a placement slip with the provided details.",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for creating a placement slip.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_placement_slip_dto_1.CreatePlacementSlipDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "Placement slip created successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: {
                    type: "string",
                    example: "Placement slip created successfully.",
                },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(create_placement_slip_dto_1.CreatePlacementSlipDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Placement slip creation failed.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function updatePlacementSlipSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({ summary: "Update Placement Slip" }), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "Placement slip ID",
        example: 1,
    }), (0, swagger_1.ApiBody)({ schema: { $ref: (0, swagger_1.getSchemaPath)(update_placement_slip_dto_1.UpdatePlacementSlipDto) } }), (0, swagger_1.ApiResponse)({ status: 200, description: "Placement slip updated." }), (0, swagger_1.ApiResponse)({ status: 404, description: "Placement slip not found." }), (0, swagger_1.ApiResponse)({ status: 400, description: "Bad request." }));
}
function deletePlacementSlipSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({ summary: "Soft Delete Placement Slip" }), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "Placement slip ID",
        example: 1,
    }), (0, swagger_1.ApiResponse)({ status: 200, description: "Placement slip deleted." }), (0, swagger_1.ApiResponse)({ status: 404, description: "Placement slip not found." }));
}
function updateQuoteComparisonReportByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiExtraModels)(update_quote_comparison_report_dto_1.UpdateQuoteComparisonReportDto), (0, swagger_1.ApiOperation)({
        summary: "Update Quote Comparison Report by ID",
        description: "Updates the Quote Comparison Report details for a specific Id, including related documents.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the Quote Comparison Report to update.",
        required: true,
        example: 1,
    }), (0, swagger_1.ApiBody)({
        description: "Payload for updating an Quote Comparison Report",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_quote_comparison_report_dto_1.UpdateQuoteComparisonReportDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote Comparison Report updated successfully",
        schema: {
            allOf: [
                {
                    properties: {
                        status: { type: "number", example: 200 },
                        message: {
                            type: "string",
                            example: "Quote Comparison Report updated successfully",
                        },
                        data: { $ref: (0, swagger_1.getSchemaPath)(update_quote_comparison_report_dto_1.UpdateQuoteComparisonReportDto) },
                    },
                },
            ],
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Quote Comparison Report not found.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Quote Comparison Report not found for the given ID.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Invalid input data.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getOpportunityContactsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve Opportunity Contacts",
        description: "Fetches the contacts associated with a specific opportunity.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityId",
        description: "The ID of the Opportunity",
        type: Number,
        example: 1,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Opportunity contacts retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Opportunity contacts retrieved successfully.",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 1 },
                            firstName: { type: "string", example: "John" },
                            lastName: { type: "string", example: "Doe" },
                            displayName: { type: "string", example: "John Doe" },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Opportunity contacts not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Opportunity contacts not found.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: {
                    type: "string",
                    example: "Failed to fetch opportunity contacts.",
                },
            },
        },
    }));
}
function generateQuoteComparisonReportSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(generate_quote_comparison_report_dto_1.QuoteComparisonReportDto), (0, swagger_1.ApiOperation)({
        summary: "Generate Quote Comparison Report",
        description: "Generates a premium and cover comparison report for selected quotes and broking slip version.",
    }), (0, swagger_1.ApiBody)({
        description: "Payload for generating quote comparison report.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(generate_quote_comparison_report_dto_1.QuoteComparisonReportDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote comparison report generated successfully.",
        schema: {
            type: "object",
            properties: {
                premiumComparisonSection: {
                    type: "object",
                    properties: {
                        headers: {
                            type: "object",
                            properties: {
                                key: { type: "string", example: "Parameters" },
                                quote_1: { type: "string", example: "Var_sys" },
                                quote_2: { type: "string", example: "Prabhakar Insurer One" },
                            },
                        },
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    key: { type: "string", example: "Net Premium" },
                                    quote_1: { type: "number", example: 2006 },
                                    quote_2: { type: "number", example: 123 },
                                },
                            },
                        },
                    },
                },
                coverDetailSection: {
                    type: "object",
                    properties: {
                        headers: {
                            type: "object",
                            properties: {
                                key: { type: "string", example: "Cover Details" },
                                quote_1: { type: "string", example: "Var_sys" },
                                quote_2: { type: "string", example: "Prabhakar Insurer One" },
                            },
                        },
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    key: {
                                        type: "string",
                                        example: "Pre- and Post-Hospitalization",
                                    },
                                    quote_1: {
                                        type: "string",
                                        example: "Verison I - Answer for Pre- and Post-Hospitalization - Broking Slip - Quote -1",
                                    },
                                    quote_2: { type: "string", example: "-" },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Required fields missing or invalid.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "Required fields are missing in the request.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Not Found. Opportunity activity or covers not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Opportunity activity not found for the given Opportunity Activity Id",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getQuoteEntryDetailsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve Quote Entry details by ID",
        description: "Fetches a quote entry along with documents, remarks and status.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "quoteId",
        type: Number,
        required: true,
        description: "The ID of the quote entry.",
        example: 1,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Quote retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Quote retrieved successfully." },
                data: { type: "object" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Quote not found.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: "Quote not found." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request. Validation failed or invalid data provided.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal Server Error. Failed to retrieve quote.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getPolicyConfirmationCdAccountDetailsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve CD account details for Policy Confirmation",
        description: "Fetches the cheque and bank details (CD account) associated with a placement slip for the given opportunity activity ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "opportunityActivityId",
        type: Number,
        required: true,
        description: "The ID of the Opportunity Activity",
        example: 501,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "CD account details retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "CD account details retrieved successfully",
                },
                data: {
                    type: "object",
                    properties: {
                        cdData: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    key: { type: "string", example: "Cheque Amount" },
                                    value: { type: "string", example: "11" },
                                },
                            },
                            example: [
                                { key: "Cheque Amount", value: "11" },
                                { key: "Cheque Date", value: "2025-06-08" },
                                { key: "Cheque Number", value: "10100" },
                                { key: "Bank Name", value: "HDFC" },
                            ],
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "CD account details not found.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: "Opportunity activity not found for ID: 501",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Bad Request.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: "CD account details retrieval failed",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
